const Dot: React.FC = (props: any) => {
  const { currentSlice, colors } = props;

  const point = currentSlice?.points?.[0];
  const color = Array.isArray(colors) ? colors[0] : colors;
  if (point) {
    return (
      <g>
        <circle
          className="transition-all duration-150"
          fill={color as string}
          r={4}
          strokeWidth={"2"}
          stroke={"1"}
          cx={point.x}
          cy={point.y}
        />
      </g>
    );
  } else {
    return null;
  }
};
export default Dot;
